import { extendObservable } from "mobx";
import { ReactiveItem } from "./ReactiveItem";

// list and search responses omit content_html (write_only on the serializer) and children,
// which the client builds from the flat path; update() fills content_html in later
export type AccordionItemPayload = Omit<
  IAccordionItem,
  "children" | "content" | "content_html"
> &
  Partial<Pick<IAccordionItem, "children" | "content" | "content_html">>;

export class ReactiveAccordionItem
  extends ReactiveItem<IAccordionItem>
  implements IAccordionItem
{
  // `declare` prevents TypeScript from emitting field initializers that would run
  // after super() and conflict with MobX observable properties set by the base class.
  declare id: number;
  declare terrace_id: number;
  declare children: Array<ReactiveAccordionItem>;
  declare title: string;
  declare description: string;
  declare has_content: boolean;
  declare modal_enabled: boolean;
  declare content: string;
  declare content_html: string;
  declare path: string;
  declare expanded: boolean | undefined;

  constructor(item: AccordionItemPayload) {
    // ReactiveItem is typed on the complete item; the partial wire payload is filled in by update()
    super(item as IAccordionItem);
    // content_html is only returned when the API is called with
    // `expand: ["content_html"]`, so it's absent on the initial list fetch
    // and arrives later via update(). Register it as observable explicitly
    // when missing so the later assignment triggers reactions.
    if (!("content_html" in item)) {
      extendObservable(this, { content_html: undefined });
    }
  }
}
